import {keyframes} from "styled-components";

export const slideLeft = keyframes`
          0% {
            left: 50%;
            transform: left;
          }
          100% {
            left: 45%;
            transform: left;
    }`;

export const slideRight = keyframes`
          0% {
            left: 45%;
            transform: left;
          }
          100% {
            left: 50%;
            transform: left;
          }
    `;
export const overlaySlideLeft = keyframes`
            0% {
                top: -400px;
                right: -250px;
                transform: rotate(50deg);
            }
            100% {
                top: -50px;
                right: -100px;
                transform: rotate(0deg);
            }`

export const overlaySlideOff = keyframes`
            0% {
                top: -50px;
                right: -100px;
                transform: rotate(0deg);
            }
            100% {
                top: 500px;
                right: 0;
                transform: rotate(50deg);
            }`
